<ion-header [translucent]="true">

    <ion-toolbar class="ion-padding-end">
        <ion-title slot="start">{{Title}}</ion-title>
        <ion-button style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end" (click)="Close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
    </ion-toolbar>

    <ion-toolbar class="filters">
        <form [formGroup]="Form">
            <ion-grid>
                <ion-row>
                    <ion-col>

                        <ng-container [ngSwitch]="Form.get('SearchType').value">

                            <ion-searchbar *ngSwitchCase="EnumConsumerCardSearchField.CardNumber"
                                placeholder="nº cartão" formControlName="CardNumber" (ionClear)="OnClearResults()"
                                (keyup.enter)="OnSearch($event)">
                            </ion-searchbar>

                            <ion-searchbar *ngSwitchDefault placeholder="NIF" formControlName="VatNumber"
                                (ionClear)="OnClearResults()" (keyup.enter)="OnSearch($event)">
                            </ion-searchbar>

                        </ng-container>

                    </ion-col>

                    <ion-col class="with-orderby">
                        <ion-buttons>
                            <ion-button [title]="'Limpar'" fill="outline" color="medium" (click)="OnClear($event)">
                                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                            </ion-button>
                            <ion-button [title]="'Pesquisar'" fill="clear" color="primary" (click)="OnSearch($event)">
                                <ion-icon slot="icon-only" name="search-outline"></ion-icon>
                            </ion-button>
                        </ion-buttons>
                    </ion-col>
                </ion-row>

                <ion-row class="search-type">
                    <ion-col>

                        <ion-button
                            [fill]="IsSearchType(EnumConsumerCardSearchField.VatNumber) ? 'solid' : 'outline'"
                            [color]="IsSearchType(EnumConsumerCardSearchField.VatNumber) ? 'primary' : 'medium'"
                            (click)="OnChangeSearchType($event, EnumConsumerCardSearchField.VatNumber)">
                            <ion-icon slot="start" name="person-outline"></ion-icon>
                            NIF
                        </ion-button>

                        <ion-button
                            [fill]="IsSearchType(EnumConsumerCardSearchField.CardNumber) ? 'solid' : 'outline'"
                            [color]="IsSearchType(EnumConsumerCardSearchField.CardNumber) ? 'primary' : 'medium'"
                            (click)="OnChangeSearchType($event, EnumConsumerCardSearchField.CardNumber)">
                            <ion-icon slot="start" name="card-outline"></ion-icon>
                            Nº Cartão
                        </ion-button>

                    </ion-col>
                </ion-row>
            </ion-grid>
        </form>
    </ion-toolbar>

</ion-header>

<ion-content class="ion-padding padding-horizontal">

    <ion-grid class="ion-no-padding ion-no-margin table" *ngIf="Data?.length > 0">

        <ion-row class="table-header">
            <ion-col size="1" class="flex-align-center flex-justify-center"></ion-col>
            <ion-col class="flex-align-center" i18n=":@@search_consumer_card_table.name">Nome</ion-col>
            <ion-col size="3" class="flex-align-center" i18n=":@@search_consumer_card_table.card">Nº Cartão</ion-col>
        </ion-row>

        <ion-row class="table-body clickable" *ngFor="let item of Data" [class.row-selected]="IsSelected(item)"
            (click)="OnSelect(item)">

            <ion-col size="1" class="flex-align-center flex-justify-center">
                <ion-icon [name]="IsSelected(item) ? 'checkmark-circle' : 'ellipse-outline'"
                    [color]="IsSelected(item) ? 'primary' : 'medium'"></ion-icon>
            </ion-col>

            <ion-col class="flex-align-center">{{item?.Name || '--'}}</ion-col>

            <ion-col size="3" class="flex-align-center">{{CardNumber(item?.CardNumber)}}</ion-col>

        </ion-row>

    </ion-grid>

    <no-items *ngIf="Data?.length == 0 && !HasSearched" icon="search-outline"
        [description]="EmptyDescription"></no-items>

    <no-items *ngIf="Data?.length == 0 && HasSearched" description="Sem resultados"></no-items>

</ion-content>

<ion-footer>
    <ion-toolbar class="ion-padding-horizontal">
        <ion-button style="margin-right: -16px;" slot="end" fill="solid" color="primary" [disabled]="!SelectedId"
            (click)="OnConfirm($event)" i18n=":@@search_consumer_card.submit">Confirmar
        </ion-button>
    </ion-toolbar>
</ion-footer>
